import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enUS from './locales/en-US.json';
import enGB from './locales/en-GB.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import ptBR from './locales/pt-BR.json';
import nl from './locales/nl.json';
import sv from './locales/sv.json';
import pl from './locales/pl.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ar from './locales/ar.json';
import da from './locales/da.json';

const resources = {
    'en-US': {
        translation: enUS,
    },
    'en-GB': {
        translation: enGB,
    },
    es: {
        translation: es,
    },
    fr: {
        translation: fr,
    },
    de: {
        translation: de,
    },
    it: {
        translation: it,
    },
    pt: {
        translation: pt,
    },
    'pt-BR': {
        translation: ptBR,
    },
    nl: {
        translation: nl,
    },
    sv: {
        translation: sv,
    },
    pl: {
        translation: pl,
    },
    ja: {
        translation: ja,
    },
    ko: {
        translation: ko,
    },
    ar: {
        translation: ar,
    },
    da: {
        translation: da,
    },
};

// Check localStorage first to respect user's previous language selection
const getInitialLanguage = () => {
    const stored = localStorage.getItem('i18nextLng')
    if (stored) {
        return stored
    }
    // Check browser language as fallback
    const browserLang = navigator.language || navigator.languages?.[0] || 'en-US'
    // Map browser language to our supported languages
    if (browserLang.startsWith('en')) {
        if (browserLang === 'en-GB') return 'en-GB'
        // Map en, en-US, or any other en variant to en-US
        return 'en-US'
    }
    // Try to match the base language code
    const baseLang = browserLang.split('-')[0]
    const supportedLangs = ['es', 'fr', 'de', 'it', 'pt', 'nl', 'sv', 'pl', 'ja', 'ko', 'ar', 'da']
    if (supportedLangs.includes(baseLang)) {
        // Handle pt-BR specifically
        if (browserLang === 'pt-BR') return 'pt-BR'
        return baseLang
    }
    // Default to en-US if no match
    return 'en-US'
}

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: getInitialLanguage(), // Use detected language instead of hardcoded en-US
        fallbackLng: ['en-US', 'en-GB'],
        debug: process.env.NODE_ENV === 'development',

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
        },

        interpolation: {
            escapeValue: false, // React already does escaping
        },
    });

export default i18n;





























